export enum TaxExcemptStatus {
    Pending = 0,
    Submitted = 1,
    Rejected = 2,
    Approved = 3,
    Invalid = 4,
}
